<script lang="ts" setup>
import { AppTableRequestPayload } from '~/composables/api/_types';
import { getDemandsOverviewColumnConfig } from '~/configs/demands';
import { FilterOperator, DemandState } from '~/enums/_types';

const { isLoading, data, pagination, request } = useDemands(
    { rowsPerPage: 20, sortBy: 'CreatedAt', descending: true },
    [{ column: 'Status', op: FilterOperator.Neq, val: DemandState.Draft }]
);

const columns = getDemandsOverviewColumnConfig();

const onRequest = async (requestPayload: AppTableRequestPayload) => {
    await request(requestPayload);
};

onMounted(() => {
    request();
});
</script>
<template>
    <div v-if="data && data.length > 0">
        <h2 class="q-mt-xl a-text-26 text-bold">{{ $t('demands.overview.last-demands') }}</h2>
        <app-table
            v-model:pagination="pagination"
            sticky-column="last"
            :loading="isLoading"
            :columns="columns"
            :rows="data"
            row-key="Id"
            @request="onRequest"
        >
            <template #body-cell-ReferenceNumber="scope">
                <q-td name="ReferenceNumber" :props="scope">
                    <app-cell-ellipsis :text="scope.row.ReferenceNumber" />
                </q-td>
            </template>
            <template #body-cell-CreatedAt="scope">
                <q-td name="CreatedAt" :props="scope">
                    {{ scope.row.CreatedAt.toLocaleString() }}
                </q-td>
            </template>
            <template #body-cell-ShipAt="scope">
                <q-td name="ShipAt" :props="scope">
                    {{ scope.row.ShipAt?.toLocaleString() }}
                </q-td>
            </template>
            <template #body-cell-Status="scope">
                <q-td
                    name="Status"
                    :props="scope"
                    class="text-bold"
                    :class="`enum-text-demandState--${scope.row.Status}`"
                >
                    {{ $t(`enums.demand_statuses.${scope.row.Status}`) }}
                </q-td>
            </template>
            <template #body-cell-Actions="scope">
                <q-td key="Actions" :props="scope">
                    <flat-btn
                        dense
                        icon="las la-file-alt"
                        :to="{
                            name: scope.row.Status === DemandState.Draft ? 'demands-id-new' : 'demands-id',
                            params: { id: scope.row.Id },
                        }"
                    />
                </q-td>
            </template>
        </app-table>
    </div>
    <div v-else>
        <h2 class="q-mt-xl q-mb-sm a-text-26 text-bold">
            {{ $t('demands.overview.noData.noDemands') }}
        </h2>
        <div class="q-mb-md a-text-20 text-on-background-1">
            {{ $t('demands.overview.noData.wantToAdd') }}
            <link-btn
                class="q-pa-none min-height-none"
                style="font-size: 1.25rem"
                text-color="on-background-1 vertical-baseline"
                :label="$t('demands.overview.noData.link')"
                :to="{ name: 'demands-new' }"
            />
        </div>
    </div>
</template>
